import { createContext, type ReactNode, useContext, useState } from 'react';
import { useBangTongHopHoaDonBanHangHoaDichVuExport } from './hooks/useBangTongHopHoaDonBanHangHoaDichVuExport';

interface BangTongHopHoaDonBanHangHoaDichVuContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
  queryParams: BanHangRecord | null;
  setQueryParams: (params: BanHangTableParams | null) => void;
  searchFieldState: BanHangRecord | null;
  setSearchFieldState: (state: BanHangRecord | null) => void;
  setExportSource: (rows: BanHangRecord[], params?: BanHangSearchParams) => void;
}

const BangTongHopHoaDonBanHangHoaDichVuContext = createContext<BangTongHopHoaDonBanHangHoaDichVuContextValue | null>(
  null
);

export const useBangTongHopHoaDonBanHangHoaDichVuContext = () => {
  const context = useContext(BangTongHopHoaDonBanHangHoaDichVuContext);
  if (!context) {
    throw new Error(
      'useBangTongHopHoaDonBanHangHoaDichVuContext must be used within BangTongHopHoaDonBanHangHoaDichVuProvider'
    );
  }
  return context;
};

export const BangTongHopHoaDonBanHangHoaDichVuProvider = ({ children }: { children: ReactNode }) => {
  const [queryParams, setQueryParams] = useState<BanHangRecord | null>(null);
  const [searchFieldState, setSearchFieldState] = useState<BanHangRecord | null>(null);
  const [exportRows, setExportRows] = useState<BanHangRecord[]>([]);
  const [exportParams, setExportParams] = useState<BanHangSearchParams | undefined>(undefined);
  const exportValue = useBangTongHopHoaDonBanHangHoaDichVuExport(exportRows, exportParams ?? queryParams ?? undefined);

  return (
    <BangTongHopHoaDonBanHangHoaDichVuContext.Provider
      value={{
        queryParams,
        setQueryParams,
        searchFieldState,
        setSearchFieldState,
        exportToExcel: exportValue.exportToExcel,
        canExport: exportValue.canExport,
        isExporting: exportValue.isExporting,
        setExportSource: (rows: BanHangRecord[], params?: BanHangSearchParams) => {
          setExportRows(rows);
          setExportParams(params ?? queryParams ?? undefined);
        }
      }}
    >
      {children}
    </BangTongHopHoaDonBanHangHoaDichVuContext.Provider>
  );
};
